module.exports = __webpack_public_path__ + "img/kg.e3bf12fa.svg";